import $ from "jquery";
import Bacon from "Bacon";

var $window = $(window);
var lastScroll = 9999999;
var triggerSetup = new Bacon.Bus();

function getContentOffset($content) {
  return $content.find('.movie-wrapper, .library-content').offset();
}

function direction(scroll) {
  var downwards = scroll >= lastScroll;
  lastScroll = scroll;
  return downwards;
}

function scrollTop() {
  return $window.scrollTop();
}

function eventTargetTop(event) {
  return $(event.target).scrollTop();
}

function scrollLeft() {
  return $window.scrollLeft();
}

function pastOffset(top, offset) {
  return top > offset;
}

function scrollPage(offset) {
  if (offset && 0 > offset.top) {
    topTo(365);
  }
}

function topTo(to) {
  $window.scrollTop(to);
}

function exists(obj) {
  return !!obj;
}

function updateContentTop(offset) {
  return offset.top + scrollTop() - 55;
}

function toggleSidebar() {
  var $validPages = $(".recordings, .library, .vuokraamo");
  var $sidebar = $validPages.find(".sidebar");
  var hiddenSidebar = $sidebar.css('display') !== 'none';

  var isMobile = $(window).width() <= 480;

  if ((isMobile || window.scrollX > 0) && hiddenSidebar) {
    $sidebar.animate({
      'width': 'hide'
    }, 350);
    $validPages.find(".content-with-sidebar").animate({
      'padding-left': '3rem'
    }, 350);
    $validPages.find(".banner-container .banner").animate({
      'margin-left': 0
    }, 350);
    $validPages.find("#recordings-toolbar").animate({
      'left': '0'
    }, 350);
    $validPages.find(".movie-wrapper.filter-content, .recordings-list").animate({
      'margin-left': '0'
    }, 350);
  }

  if ((isMobile || window.scrollX === 0) && !hiddenSidebar) {
    $sidebar.animate({
      'width': 'show'
    }, 350);
    $validPages.find(".content-with-sidebar").animate({
      'padding-left': 260
    }, 350);
    $validPages.find(".banner-container .banner").animate({
      'margin-left': 260
    }, 350);
    $validPages.find("#recordings-toolbar").animate({
      'left': '260px'
    }, 350);
    $validPages.find(".movie-wrapper.filter-content, .recordings-list").animate({
      'margin-left': 'auto'
    }, 350);
  }
}

var contentPositionNeedsUpdate = Bacon.mergeAll([triggerSetup, Bacon.fromEventTarget(document.body, "webkitTransitionEnd"), Bacon.fromEventTarget(document.body, "transitionend"), Bacon.fromEventTarget(document.body, "oTransitionEnd")]);
var windowScrollProperty = $window.asEventStream('scroll touchmove').map(scrollTop).toProperty(0);
var contentTop = Bacon.constant($("#content")).sampledBy(contentPositionNeedsUpdate, getContentOffset).filter(exists).map(updateContentTop).toProperty(0).skipDuplicates();

contentTop.onValue(function () {
}); // bacon late subscription requirement
triggerSetup.push(true);
export default {
  contentTop: contentTop,
  updateContentTop: triggerSetup.push,
  downwards: windowScrollProperty.skipDuplicates().map(direction),
  window: windowScrollProperty,
  wrapper: $('.wrapper').asEventStream('scroll touchmove').map(eventTargetTop).toProperty(0),
  pastContent: windowScrollProperty.combine(contentTop, pastOffset),
  top: scrollTop,
  left: scrollLeft,
  trigger: function () {
    $window.trigger('scroll');
  },
  topTo: topTo,
  reset: function () {
    window.setTimeout(function () {
      $("html").removeClass("elisa-navi__segment-header__sticky");
      topTo(0);
    }, 100);
  },
  page: scrollPage,
  toWindowTop: function () {
    window.scrollTo(0, 0);
  },
  scrollIntoView: function (el) {
    if (el instanceof $) {
      el = el[0];
    }
    el.scrollIntoView();
  },
  toggleSidebar: toggleSidebar
};



// WEBPACK FOOTER //
// ./web/js/scroll.js